export default __webpack_public_path__ + "static/media/project5.140f5a78.webp";